import { AccessDenied } from '@components/access-denied';
import PropTypes from 'prop-types';
import { ErrorBoundary as Boundary } from 'react-error-boundary';

const ErrorFallback = ({ error }) => {
  console.log({ error });
  return (
    <AccessDenied />
  );
};

const ErrorBoundary = ({ children }) => (
  <Boundary FallbackComponent={ErrorFallback}>
    {children}
  </Boundary>
);

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

ErrorFallback.defaultProps = {
  error: {},
};

ErrorFallback.propTypes = {
  error: PropTypes.shape({}),
};

export default ErrorBoundary;
